import React, {ReactNode} from 'react'
import {IndicatorProps} from './index'
import {IndicatorType} from '../../Types'

const UnknownIndicator = ({indicator}: IndicatorProps<IndicatorType, null>): ReactNode => {
    return indicator['title']
}
export default UnknownIndicator
